import { axiosInstance } from "../common";

const ENDPOINT = `/project`;

export const getProjectDetails = (token) => axiosInstance.get(ENDPOINT, {
    params: {
        token
    }
}).then(({ data, meta }) => ({...data, meta}))